module.exports = {"corp_url":"stage-corp.evernote.com","service_url":"stage.evernote.com"}


//////////////////
// WEBPACK FOOTER
// ./inc/environment.json
// module id = 337
// module chunks = 0 1